import React from 'react'

import { FoodRestrictionSearchContent } from '../components/search/FoodRestrictionSearchPage/FoodRestrictionSearchPageContent/FoodRestrictionSearchPageContent'

export const FoodRestrictionSearchPage = () => {
  return <FoodRestrictionSearchContent />
}
